// Types
import type { TAutomatedEmailTab } from "~/modules/opportunities/automated-email/show/types";
import { EAutomatedEmailTab } from "~/modules/opportunities/automated-email/show/types";


const AUTOMATED_EMAIL_TABS: TAutomatedEmailTab[] = [
  { key: EAutomatedEmailTab.OUTBOX, label: 'Outbox' },
  { key: EAutomatedEmailTab.SENT, label: 'Sent' },
  { key: EAutomatedEmailTab.DASHBOARD, label: 'Dashboard' },
  { key: EAutomatedEmailTab.SETTINGS, label: 'Settings' },
];

const AUTOMATED_EMAIL_DOMAIN_GATE_MESSAGE: string =
  'Your domain is not yet configured, talk to your manager in order to update your DNS status.';

const AUTOMATED_EMAIL_DOMAIN_ACTIVE_STATE = 'active' as const;

export {
  AUTOMATED_EMAIL_TABS,
  AUTOMATED_EMAIL_DOMAIN_GATE_MESSAGE,
  AUTOMATED_EMAIL_DOMAIN_ACTIVE_STATE,
};
